/**
 * plant-news.js
 * 植物・園芸・農業ニュースカテゴリページ。
 * - タブ+スワイプ同期、絞り込み(タグfacet)、Series展開はクライアント側のみで完結
 * - ニュース本体は plant-news-feed Worker(Cloudflare KV)から取得
 * - MY AREAはuser-region-follows Workerでフォローエリアを取得し、
 *   get-events-cache経由でLeafla本体のイベントをフィルタして表示する
 */
(function () {
  "use strict";

  /* ---------- AdSense広告(2026-08-30追加) ----------
     このファイルはCloudflare KVから取得したJSONをクライアント側でHTML文字列に
     組み立て.innerHTMLへ流し込む方式のため、Liquidテンプレート側(main-article.liquid等)
     のように<script>タグを広告HTMLへ埋め込んでも実行されない(innerHTML経由の
     <script>はブラウザが実行しない)。そのため、HTML挿入後に明示的にJSで
     (adsbygoogle=window.adsbygoogle||[]).push({})を呼ぶ必要がある。
     data-ad-slotはsections/main-article.liquidの既存ユニットを流用(AdSenseの
     広告ユニットは複数ページで使い回して問題無い)。 */
  var ADSENSE_CLIENT = "ca-pub-3139962328628180";

  function buildAdUnitHtml(extraLiClass) {
    var wrapOpen = extraLiClass ? '<li class="' + extraLiClass + '">' : "";
    var wrapClose = extraLiClass ? "</li>" : "";
    return wrapOpen + '<div class="adu-block"><p class="adu-label">広告</p>' +
      '<ins class="adsbygoogle" style="display:block" data-ad-client="' + ADSENSE_CLIENT + '" data-ad-slot="9939609043" data-ad-format="auto" data-full-width-responsive="true"></ins>' +
      '</div>' + wrapClose;
  }

  // innerHTML経由で挿入した<ins class="adsbygoogle">はスクリプトが自動実行されない
  // ため、挿入後にこれを呼んで未処理分だけ明示的にpushする。
  function activateAdUnitsWithin(root) {
    if (!root || !window.adsbygoogle) return;
    var inses = qsa("ins.adsbygoogle:not([data-adsbygoogle-status])", root);
    inses.forEach(function () {
      try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (e) { /* noop */ }
    });
  }

  var REGION_LABELS = {
    HOKKAIDO: "北海道", TOHOKU: "東北", KANTO: "関東", CHUBU: "中部", KANSAI: "関西",
    SHIKOKU: "四国", CHUGOKU: "中国", KYUSHU: "九州", OKINAWA: "沖縄",
    DOUO: "道央", TOKACHI: "十勝", DONAN: "道南", OKHOTSK: "オホーツク", DOHOKU: "道北", KUSHIRO: "釧路・根室",
    AOMORI: "青森県", IWATE: "岩手県", MIYAGI: "宮城県", AKITA: "秋田県", YAMAGATA: "山形県", FUKUSHIMA: "福島県",
    TOKYO: "東京都", KANAGAWA: "神奈川県", CHIBA: "千葉県", SAITAMA: "埼玉県", IBARAKI: "茨城県", TOCHIGI: "栃木県", GUNMA: "群馬県",
    AICHI: "愛知県", SHIZUOKA: "静岡県", GIFU: "岐阜県", NAGANO: "長野県", YAMANASHI: "山梨県", NIIGATA: "新潟県", TOYAMA: "富山県", ISHIKAWA: "石川県", FUKUI: "福井県",
    OSAKA: "大阪府", KYOTO: "京都府", HYOGO: "兵庫県", NARA: "奈良県", SHIGA: "滋賀県", WAKAYAMA: "和歌山県",
    TOKUSHIMA: "徳島県", KAGAWA: "香川県", EHIME: "愛媛県", KOCHI: "高知県",
    HIROSHIMA: "広島県", OKAYAMA: "岡山県", YAMAGUCHI: "山口県", SHIMANE: "島根県", TOTTORI: "鳥取県",
    FUKUOKA: "福岡県", SAGA: "佐賀県", NAGASAKI: "長崎県", KUMAMOTO: "熊本県", OITA: "大分県", MIYAZAKI: "宮崎県", KAGOSHIMA: "鹿児島県",
    NAHA: "那覇市", ISHIGAKI: "石垣島"
  };

  var FEED_URL = window.LEAFLA_PLANT_NEWS_FEED_URL;
  var FOLLOWS_BASE_URL = window.LEAFLA_USER_REGION_FOLLOWS_URL;
  var EVENTS_API_BASE = window.LEAFLA_EVENTS_API_BASE;
  var CUSTOMER_EMAIL = window.LEAFLA_CUSTOMER_EMAIL || "";
  var TABS = window.LEAFLA_PLANT_NEWS_TABS || [];
  var AREAS_URL = window.LEAFLA_PLANT_NEWS_AREAS_URL || "/pages/plant-news-areas";
  // compactモード(ホームページ埋め込み用): FEATURE/SERIES演出・facet絞り込みを省略し、
  // 各タブ上位数件+「もっと見る」だけの軽量表示にする。データ取得・タブ構成はfull版と共通。
  var COMPACT = !!window.LEAFLA_PLANT_NEWS_COMPACT;
  var COMPACT_ITEM_LIMIT = 5;
  var COMPACT_MORE_URL = "/pages/plant-news";

  var state = {
    activeIndex: 0,
    selectedTags: {},
    expandedSeries: {},
    feedByCategory: {},
    feedLoaded: false,
    feedError: false,
    followedRegions: [],
    myAreaEvents: [],
    myAreaLoaded: false,
    regionEventsPreview: {},
    regionEventsPreviewLoaded: false,
    weekendPlans: [],
    weekendPlansLoaded: false,
    weekendPlansError: false
  };

  var scrollLock = false;
  var unlockTimer = null;

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function formatDate(iso) {
    if (!iso) return "";
    var d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    return d.toLocaleDateString("ja-JP", { year: "numeric", month: "numeric", day: "numeric" });
  }

  // NewsPicks/SmartNews的に直近は相対時刻、それより古いものは日付表示にする。
  function formatRelativeTime(iso) {
    if (!iso) return "";
    var d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    var diffMin = Math.floor((Date.now() - d.getTime()) / 60000);
    if (diffMin < 1) return "たった今";
    if (diffMin < 60) return diffMin + "分前";
    var diffHour = Math.floor(diffMin / 60);
    if (diffHour < 24) return diffHour + "時間前";
    var diffDay = Math.floor(diffHour / 24);
    if (diffDay < 7) return diffDay + "日前";
    return formatDate(iso);
  }

  function buildMetaHtml(source, iso) {
    var time = formatRelativeTime(iso);
    if (source && time) return '<span class="pn-card-source">' + escapeHtml(source) + '</span><span class="pn-card-meta-sep">・</span>' + escapeHtml(time);
    if (source) return '<span class="pn-card-source">' + escapeHtml(source) + '</span>';
    return escapeHtml(time);
  }

  // カテゴリごとにコンテンツ量が大きく違うため、パネルをflexで等高ストレッチさせず
  // アクティブなパネルの実高さに.pn-main-scrollをJSで追従させる(可変高さ)。
  function updateScrollerHeight() {
    var scroller = qs("#pnMainScroll");
    if (!scroller) return;
    var panels = qsa(".pn-panel", scroller);
    var activePanel = panels[state.activeIndex];
    if (!activePanel) return;
    scroller.style.height = activePanel.scrollHeight + "px";
  }

  /* ---------- tab / swipe sync ---------- */
  // 2026-08-29 追記: setActiveIndex()はタブハイライト変更に加えて高さ再計算・
  // 縦スクロール移動という「副作用の重い」処理を含む。フリック中(スクロール中の
  // #pnMainScroll自身)にscroller.style.heightを書き換えると、実機(特にスマホ)で
  // タッチスクロールの物理挙動が乱れ、軽くフリックしただけで複数パネル分
  // 吹っ飛ぶ/中途半端に切り替わる不具合が発生することが確認された。
  // そのため「タブのハイライトだけを更新する軽量処理」と「高さ再計算・縦スクロール
  // 移動まで含めた本切替」を分離し、本切替はスクロールが完全に収まった時だけ行う
  // (initScrollSync参照)。
  function updateTabHighlight(idx) {
    qsa(".pn-tab").forEach(function (el) {
      el.classList.toggle("pn-tab--active", Number(el.getAttribute("data-idx")) === idx);
    });
    var tabRow = qs("#pnTabRow");
    if (tabRow) {
      var tabEl = tabRow.querySelector('[data-idx="' + idx + '"]');
      if (tabEl && tabEl.scrollIntoView) {
        tabEl.scrollIntoView({ inline: "center", block: "nearest", behavior: "smooth" });
      }
    }
  }

  function setActiveIndex(idx) {
    var changed = idx !== state.activeIndex;
    state.activeIndex = idx;
    updateTabHighlight(idx);
    // カテゴリを実際に切り替えた時だけ、縦スクロール位置をタブバーの位置まで戻す。
    // これが無いと、途中までスクロールした状態でフリックした際に、次のカテゴリの
    // 内容が(先頭からではなく)前カテゴリと同じスクロール位置から見え始めてしまう。
    // .pn-tab-barはposition:stickyのため、固定表示中はscrollIntoView()が
    // 「既に見えている」と判定して何もスクロールしない(実際のページ位置に関わらず
    // 常にヘッダー直下に描画されているため)。そのためsticky要素自体ではなく、
    // 通常フローの#pnMainScrollを基準に、ヘッダー+タブバー分のオフセットを引いた
    // 位置までwindow.scrollToで明示的にスクロールする。
    if (changed) scrollPanelToTop();
    updateScrollerHeight();
    updateFlickNavButtons();
  }

  // 矢印ボタンの有効/無効を現在位置に合わせて更新する。ボタン自体は「横に
  // 続きがある」ことを一目で伝えるヒントを兼ねるため、クリックでの切り替えも
  // フリックと同じjumpToPanel()を使う。
  function updateFlickNavButtons() {
    var prevBtn = qs("#pnFlickPrev");
    var nextBtn = qs("#pnFlickNext");
    var maxIdx = (TABS.length || 1) - 1;
    if (prevBtn) prevBtn.disabled = state.activeIndex <= 0;
    if (nextBtn) nextBtn.disabled = state.activeIndex >= maxIdx;
  }

  function scrollPanelToTop() {
    var mainScroll = qs("#pnMainScroll");
    var tabBar = qs(".pn-tab-bar");
    if (!mainScroll) return;
    var headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--header-height")) || 0;
    var tabBarH = tabBar ? tabBar.offsetHeight : 0;
    var targetY = window.scrollY + mainScroll.getBoundingClientRect().top - headerH - tabBarH;
    if (targetY < window.scrollY) {
      window.scrollTo({ top: Math.max(0, targetY), behavior: "smooth" });
    }
  }

  function jumpToPanel(idx) {
    var scroller = qs("#pnMainScroll");
    if (!scroller) return;
    scrollLock = true;
    window.clearTimeout(unlockTimer);
    var unlock = function () {
      window.clearTimeout(unlockTimer);
      scroller.removeEventListener("scrollend", unlock);
      scrollLock = false;
    };
    scroller.addEventListener("scrollend", unlock);
    // scrollendが発火しない環境向けのフォールバック。主信号はscrollend。
    unlockTimer = window.setTimeout(unlock, 1000);
    var width = scroller.clientWidth || 1;
    scroller.scrollTo({ left: idx * width, behavior: "smooth" });
    setActiveIndex(idx);
  }

  function initScrollSync() {
    var scroller = qs("#pnMainScroll");
    if (!scroller) return;
    var indexFromScrollPosition = function () {
      var width = scroller.clientWidth || 1;
      return Math.round(scroller.scrollLeft / width);
    };

    // 2026-08-29 再修正(2回目): 前回、scrollイベントのたびにsetActiveIndex()
    // (=高さ再計算・縦スクロール移動込みの本切替)を呼ぶ方式にしたが、実機の
    // スマホで「軽くフリックしただけで複数パネル分吹っ飛ぶ/中途半端に切り替わる」
    // 不具合が発生した。原因は、フリック中(タッチスクロール中)の#pnMainScroll自身の
    // 高さをupdateScrollerHeight()で書き換えると、ブラウザのタッチスクロール物理
    // 演算が乱れるため。
    // そこで「見た目の追従」と「本切替」を分離する:
    //   - スクロール中は指の動きに合わせて軽量なタブハイライトだけをrAFで追従させる
    //     (副作用無し、高さは変えない)
    //   - 高さ再計算・縦スクロール移動を含む本切替は、スクロールが完全に収まって
    //     から(scrollend、無ければデバウンス)1回だけ行う
    var ticking = false;
    scroller.addEventListener("scroll", function () {
      if (scrollLock || ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var idx = indexFromScrollPosition();
        if (idx !== state.activeIndex) updateTabHighlight(idx);
        ticking = false;
      });
    });

    var commitFromScrollPosition = function () {
      var idx = indexFromScrollPosition();
      if (idx !== state.activeIndex) setActiveIndex(idx);
    };
    if ("onscrollend" in window) {
      scroller.addEventListener("scrollend", function () {
        if (scrollLock) return;
        commitFromScrollPosition();
      });
    } else {
      var scrollTimer = null;
      scroller.addEventListener("scroll", function () {
        if (scrollLock) return;
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(commitFromScrollPosition, 80);
      });
    }
  }

  // PCはタッチ操作のスワイプが無いため、マウスドラッグでカルーセルのように
  // 「軽くフリック」しただけで次/前のパネルへ切り替わるようにする。
  // (生のscrollLeft追従+ネイティブscroll-snapの組み合わせだと、フル幅の半分近く
  //  ドラッグしないと切り替わらず「フリックが重い」体感になっていたため、
  //  距離しきい値+速度しきい値を見てjumpToPanelで明示的に1枚だけ送る方式に変更)
  function initDragScroll() {
    var scroller = qs("#pnMainScroll");
    if (!scroller) return;
    var isDown = false;
    var startX = 0;
    var startScrollLeft = 0;
    var lastX = 0;
    var lastT = 0;
    var velocity = 0; // px/ms (直近の移動速度)
    var DISTANCE_THRESHOLD = 60; // px
    var VELOCITY_THRESHOLD = 0.35; // px/ms

    scroller.addEventListener("mousedown", function (e) {
      isDown = true;
      scroller.classList.add("pn-dragging");
      startX = lastX = e.pageX;
      startScrollLeft = scroller.scrollLeft;
      lastT = Date.now();
      velocity = 0;
    });
    scroller.addEventListener("mousemove", function (e) {
      if (!isDown) return;
      e.preventDefault();
      var now = Date.now();
      var dt = Math.max(1, now - lastT);
      velocity = (e.pageX - lastX) / dt;
      lastX = e.pageX;
      lastT = now;
      scroller.scrollLeft = startScrollLeft - (e.pageX - startX);
    });
    window.addEventListener("mouseup", function () { finishDrag(); });
    scroller.addEventListener("mouseleave", function () { finishDrag(); });

    function finishDrag() {
      if (!isDown) return;
      isDown = false;
      scroller.classList.remove("pn-dragging");
      var totalDelta = lastX - startX;
      var idx = state.activeIndex;
      var maxIdx = (TABS.length || 1) - 1;
      var crossed = Math.abs(totalDelta) > DISTANCE_THRESHOLD || Math.abs(velocity) > VELOCITY_THRESHOLD;
      if (crossed) {
        idx = totalDelta < 0 ? Math.min(idx + 1, maxIdx) : Math.max(idx - 1, 0);
      }
      jumpToPanel(idx);
    }

    // ドラッグ末尾のclickでリンク誤発火するのを防ぐ(カード内リンクのドラッグ誤クリック対策)。
    scroller.addEventListener("click", function (e) {
      if (Math.abs(lastX - startX) > 5) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  /* ---------- facet filter ---------- */
  function matchesTagFilters(item) {
    var dims = Object.keys(state.selectedTags);
    for (var i = 0; i < dims.length; i++) {
      var dim = dims[i];
      var wanted = state.selectedTags[dim];
      if (!wanted || wanted.length === 0) continue;
      var itemTags = (item.tags && item.tags[dim]) || [];
      var hit = wanted.some(function (w) { return itemTags.indexOf(w) >= 0; });
      if (!hit) return false;
    }
    return true;
  }

  function countFilteredItems() {
    var total = 0;
    Object.keys(state.feedByCategory).forEach(function (catId) {
      total += state.feedByCategory[catId].filter(matchesTagFilters).length;
    });
    return total;
  }

  function updateFacetStatus() {
    var text = "絞り込み中：" + countFilteredItems() + "件のニュースが対象";
    qsa(".pn-facet-status-text").forEach(function (el) { el.textContent = text; });
  }

  function syncFacetCheckboxes() {
    qsa(".pn-facet-option input[type='checkbox']").forEach(function (cb) {
      var dim = cb.getAttribute("data-dim");
      var value = cb.getAttribute("data-value");
      cb.checked = ((state.selectedTags[dim]) || []).indexOf(value) >= 0;
    });
  }

  function renderChips() {
    var wrap = qs("#pnChipRowWrap");
    var row = qs("#pnChipRow");
    if (!wrap || !row) return;
    var chips = [];
    Object.keys(state.selectedTags).forEach(function (dim) {
      (state.selectedTags[dim] || []).forEach(function (label) { chips.push({ dim: dim, label: label }); });
    });
    if (chips.length === 0) {
      wrap.style.display = "none";
      row.innerHTML = "";
      return;
    }
    wrap.style.display = "";
    row.innerHTML = chips.map(function (c) {
      return '<li><button type="button" class="pn-chip" data-action="remove-chip" data-dim="' + escapeHtml(c.dim) + '" data-value="' + escapeHtml(c.label) + '">' +
        '<span>' + escapeHtml(c.label) + '</span>' +
        '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
        '</button></li>';
    }).join("");
  }

  function toggleTag(dim, label) {
    var current = state.selectedTags[dim] || [];
    var idx = current.indexOf(label);
    var next = idx >= 0 ? current.filter(function (x) { return x !== label; }) : current.concat([label]);
    state.selectedTags = Object.assign({}, state.selectedTags);
    state.selectedTags[dim] = next;
    renderChips();
    syncFacetCheckboxes();
    updateFacetStatus();
    renderAllPanels();
  }

  function clearTags() {
    state.selectedTags = {};
    renderChips();
    syncFacetCheckboxes();
    updateFacetStatus();
    renderAllPanels();
  }

  /* ---------- news item rendering ----------
     カード装飾は使わず、NewsPicks的なニュースリスト行(.pn-item)として描画する。
     PC/SPで別DOMは作らず、CSS Gridの列数切り替えだけで見た目を変える。
     記事タイトル(を含む行全体)がそのままリンクになり、別途「元記事を読む」ボタンは置かない。
     SERIES(連載)は通常リストに混ぜず、buildSeriesBoxHtmlで専用ボックスとして描画する。 */
  function buildItemHtml(item, opts) {
    opts = opts || {};
    var attrs = item.is_original ? "" : ' target="_blank" rel="noopener"';
    // 2026-09-12: 画像が生成できている記事はサムネイル表示する(buildEventItemHtmlと
    // 同じ.pn-item-thumbを流用)。画像が無い記事(過去の生成失敗分等)は今まで通りテキストのみ。
    var thumb = item.image ? '<div class="pn-item-thumb"><img src="' + escapeHtml(item.image) + '" alt="" loading="lazy"></div>' : '';
    var html = '<li class="pn-item">';
    html += '<a class="pn-item-link" href="' + escapeHtml(item.url) + '"' + attrs + '>';
    if (opts.showCategory) {
      html += '<div class="pn-item-top"><span class="pn-badge">' + escapeHtml(item.categoryLabel || "") + '</span></div>';
    }
    html += '<div class="pn-item-body"><div class="pn-item-text">' +
      '<p class="pn-item-title">' + escapeHtml(item.title) + '</p>' +
      '<p class="pn-item-meta">' + buildMetaHtml(item.source, item.published_at) + '</p>' +
      '</div>' + thumb + '</div>';
    html += '</a></li>';
    return html;
  }

  /* ---------- FEATURE / pickup(パネル上部のヒーロー枠)----------
     カテゴリ内で最新の1件を大きな見出しで見せ、続く数件をピックアップとして横に添える。
     ピックアップ件数が無ければ1カラムのソロ表示にフォールバックする。 */
  function buildFeatureSectionHtml(featureInnerHtml, pickupTitle, pickupItemsHtml) {
    if (!pickupItemsHtml) return '<div class="pn-feature-solo">' + featureInnerHtml + '</div>';
    return '<div class="pn-feature"><div>' + featureInnerHtml + '</div>' +
      '<div class="pn-pickup"><p class="pn-pickup-title">' + escapeHtml(pickupTitle) + '</p>' +
      '<ul class="pn-pickup-list">' + pickupItemsHtml + '</ul></div></div>';
  }

  function buildFeatureNewsInnerHtml(item, showCategory) {
    var attrs = item.is_original ? "" : ' target="_blank" rel="noopener"';
    var badges = '<span class="pn-badge pn-badge--feature">FEATURE</span>';
    if (showCategory && item.categoryLabel) badges += '<span class="pn-badge">' + escapeHtml(item.categoryLabel) + '</span>';
    // 2026-09-12: 画像がある記事はヘッドラインの上にサムネイルを表示する。
    var thumb = item.image ? '<div class="pn-feature-thumb"><img src="' + escapeHtml(item.image) + '" alt="" loading="lazy"></div>' : '';
    return '<a class="pn-item-link" href="' + escapeHtml(item.url) + '"' + attrs + '>' +
      thumb +
      '<div class="pn-item-top">' + badges + '</div>' +
      '<h3 class="pn-feature-headline">' + escapeHtml(item.title) + '</h3>' +
      '<p class="pn-feature-meta">' + buildMetaHtml(item.source, item.published_at) + '</p>' +
      '</a><div class="pn-feature-rule"></div>';
  }

  function buildPickupNewsItemHtml(item) {
    var attrs = item.is_original ? "" : ' target="_blank" rel="noopener"';
    // 2026-09-12: 画像がある記事はbuildPickupEventItemHtmlと同じ.pn-pickup-item-thumbで表示。
    var thumb = item.image ? '<div class="pn-pickup-item-thumb"><img src="' + escapeHtml(item.image) + '" alt="" loading="lazy"></div>' : '';
    return '<li class="pn-pickup-item"><a class="pn-pickup-item-link" href="' + escapeHtml(item.url) + '"' + attrs + '>' + thumb +
      '<div class="pn-pickup-item-body">' +
      '<p class="pn-pickup-item-title">' + escapeHtml(item.title) + '</p>' +
      '<p class="pn-pickup-item-meta">' + buildMetaHtml(item.source, item.published_at) + '</p>' +
      '</div></a></li>';
  }

  /* ---------- SERIES専用ボックス ----------
     折りたたみ時は直近4件(最新側)のみ表示し、既存のexpandedSeries状態+
     data-action="toggle-series"のイベント委譲(initEvents参照)をそのまま再利用する。 */
  function buildSeriesBoxHtml(item) {
    var members = item.members || [];
    var total = item.event_count || members.length;
    var expanded = !!state.expandedSeries[item.id];
    var numbered = members.map(function (m, idx) { return { m: m, num: idx + 1, isLatest: idx === members.length - 1 }; });
    var visible = expanded ? numbered : numbered.slice(-4);
    var episodesHtml = visible.map(function (row) {
      var mAttrs = row.m.is_original ? "" : ' target="_blank" rel="noopener"';
      return '<a class="pn-episode" href="' + escapeHtml(row.m.url) + '"' + mAttrs + '>' +
        '<span class="pn-episode-num' + (row.isLatest ? ' pn-episode-num--latest' : '') + '">' + String(row.num).padStart(2, "0") + '</span>' +
        '<span class="pn-episode-text"><span class="pn-episode-title">' + escapeHtml(row.m.title) + '</span>' +
        '<span class="pn-episode-meta">' + buildMetaHtml(row.m.source, row.m.published_at) + '</span></span></a>';
    }).join("");
    var toggleHtml = members.length > 4
      ? '<div class="pn-series-box-foot"><button type="button" class="pn-series-box-btn" data-action="toggle-series" data-id="' + escapeHtml(item.id) + '">' +
        (expanded ? "閉じる" : "全" + total + "件を見る") +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="#000" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button></div>'
      : '';
    var attrs = item.is_original ? "" : ' target="_blank" rel="noopener"';
    return '<div class="pn-series-box">' +
      '<div class="pn-series-box-head"><span class="pn-badge pn-badge--series">タイムライン</span>' +
      '<h3 class="pn-series-box-title"><a href="' + escapeHtml(item.url) + '"' + attrs + '>' + escapeHtml(item.title) + '</a></h3></div>' +
      '<p class="pn-series-box-range">全' + total + '件</p>' +
      '<div class="pn-episode-grid">' + episodesHtml + '</div>' +
      toggleHtml + '</div>';
  }

  /* ---------- 特集(編集部キュレーション)カード ----------
     2026-08-30: 当初は個別の単発記事を並べていたが、「特集」は本来、複数の
     関連ニュースを1本のオリジナル記事へ束ねたSeries(タイムライン)記事を
     指す(ユーザー確認済み)。サムネイル画像も、複数ニュースを踏まえて設計する
     専用の生成方式(leafra-news-pipelineのtimeline_thumbnail_runtime_prompt、
     単発記事用のシンプルな画像生成とは別物)を使う。カードには、まとめ元の
     参照記事(出典)一覧も併記し、「書き換えたオリジナル記事+参照元の明示」
     という構成を崩さないようにする。ALLタブの固定表示・「特集」タブの一覧、
     どちらもこの同じカードを使う(バックエンド側で手動キュレーションされた
     idに"featured": trueが立ち、専用タブ用に"featured"カテゴリへも複製配置
     される。ALLタブではその複製バケットは使わず各アイテムのfeaturedフラグで
     通常マージ結果から抽出する、renderNewsPanel参照、重複回避)。 */
  var FEATURED_CATEGORY_ID = "featured";

  function buildFeaturedCardHtml(item) {
    var attrs = item.is_original ? "" : ' target="_blank" rel="noopener"';
    var thumb = item.image ? '<div class="pn-featured-card-thumb"><img src="' + escapeHtml(item.image) + '" alt="" loading="lazy"></div>' : "";
    var isSeries = item.type === "series";
    // 2026-08-31: 「特集」タブ自体を「タイムライン」に改称したため、重複する
    // 「特集」バッジは廃止し「タイムライン」バッジのみにした。
    var badges = isSeries ? '<span class="pn-badge pn-badge--series">タイムライン</span>' : "";
    var metaLine = isSeries
      ? "全" + (item.event_count || (item.members || []).length) + "件の関連ニュースをもとに作成"
      : buildMetaHtml(item.source, item.published_at);
    var members = (item.members || []).slice(-4);
    // 参照元(出典)一覧。カード全体を1つのリンクにすると内部にリンクを
    // 入れ子にできないため、メインの画像+見出しへのリンクとは別に、
    // カード下部の独立した一覧として並べる(SERIESボックスのepisode行と
    // 同じ考え方)。
    var refsHtml = isSeries && members.length
      ? '<ul class="pn-featured-card-refs">' + members.map(function (m) {
          var mAttrs = m.is_original ? "" : ' target="_blank" rel="noopener"';
          return '<li><a href="' + escapeHtml(m.url) + '"' + mAttrs + '>' + escapeHtml(m.title) + '</a>' +
            '<span class="pn-featured-card-ref-source">' + escapeHtml(m.source || "") + '</span></li>';
        }).join("") + '</ul>'
      : "";
    return '<div class="pn-featured-card">' +
      '<a class="pn-featured-card-link" href="' + escapeHtml(item.url) + '"' + attrs + '>' + thumb +
      '<div class="pn-featured-card-body">' + badges +
      '<p class="pn-featured-card-title">' + escapeHtml(item.title) + '</p>' +
      '<p class="pn-featured-card-meta">' + metaLine + '</p>' +
      '</div></a>' + refsHtml + '</div>';
  }

  // 特集の2件目以降を並べる、小さめのリスト項目(参照元一覧までは出さず
  // サムネイル+タイトル+件数のみ。既存の.pn-pickup-itemと同じ考え方)。
  // 特集専用: 通常のpn-pickup-item-thumb(56x56正方形)ではなく、画像を主役に
  // した面長(横長)サムネイルを使う(2026-08-31、ユーザー指摘で正方形から変更。
  // 特集は全件サムネイル画像が保証されているため、通常ニュースのpickupより
  // 画像を大きく見せる)。
  function buildFeaturedPickupItemHtml(item) {
    var attrs = item.is_original ? "" : ' target="_blank" rel="noopener"';
    var thumb = item.image ? '<div class="pn-featured-pickup-thumb"><img src="' + escapeHtml(item.image) + '" alt="" loading="lazy"></div>' : "";
    var meta = item.type === "series"
      ? "全" + (item.event_count || (item.members || []).length) + "件の関連ニュースをもとに作成"
      : buildMetaHtml(item.source, item.published_at);
    return '<li class="pn-pickup-item pn-featured-pickup-item"><a class="pn-pickup-item-link" href="' + escapeHtml(item.url) + '"' + attrs + '>' + thumb +
      '<div class="pn-pickup-item-body">' +
      '<p class="pn-pickup-item-title">' + escapeHtml(item.title) + '</p>' +
      '<p class="pn-pickup-item-meta">' + meta + '</p>' +
      '</div></a></li>';
  }

  var FEATURED_PICKUP_COUNT = 5;

  // 特集一覧: 最新1件を大きなカードとして上部(PCは左)に、続く数件は面長
  // サムネイル付きの小さいリストで右(PCは右カラム、SPはカードの下)に並べる
  // (既存のbuildFeatureSectionHtml、通常ニュースのFEATURE+続けて読むと同じ
  // 仕組みを再利用)。それ以外の残り全件は、通常ニュースの「新着ニュース」
  // 2カラムリストと全く同じ見た目・挙動で「その他のタイムライン」という
  // 見出しの下に並べる(2026-08-31、ユーザー要望)。
  function buildFeaturedGridHtml(items) {
    if (items.length === 0) return "";
    var hero = buildFeaturedCardHtml(items[0]);
    var pickup = items.slice(1, 1 + FEATURED_PICKUP_COUNT);
    var rest = items.slice(1 + FEATURED_PICKUP_COUNT);
    var pickupHtml = pickup.map(buildFeaturedPickupItemHtml).join("");
    // 2026-09-12: 通常ニュースの「FEATURE記事の続き」を読む文脈と違い、タイムラインの
    // ピックアップは別々のまとめ記事が並ぶだけなので「続けて読む」という文言だと
    // クリック可能なCTAのように誤解されやすい(ユーザー指摘)。ラベルを見出しとして
    // 明確に読める文言に変更。
    var html = buildFeatureSectionHtml(hero, "新着のタイムライン", pickupHtml);
    if (rest.length > 0) {
      html += '<div class="pn-sec-label"><span class="pn-sec-label-text">その他のタイムライン</span><span class="pn-sec-label-rule"></span></div>';
      html += '<ul class="pn-list">' + rest.map(function (item) {
        // 「新着ニュース」の通常アイテムと全く同じbuildItemHtmlを再利用し、
        // カテゴリバッジの代わりに「タイムライン」バッジを出す。
        return buildItemHtml(Object.assign({}, item, { categoryLabel: "タイムライン" }), { showCategory: true });
      }).join("") + '</ul>';
    }
    return html;
  }

  /* ---------- イベント系FEATURE(日付を主役にしたヒーロー) ----------
     MY AREA・イベント施設タブのリーフラ実イベントで共通利用する。 */
  function buildFeatureEventInnerHtml(ev, badgeLabel) {
    var d = ev.event_date ? new Date(ev.event_date + "T00:00:00") : null;
    var validDate = d && !isNaN(d.getTime());
    var dayLabel = validDate ? (d.getMonth() + 1) + "/" + String(d.getDate()).padStart(2, "0") : "";
    var dowLabel = validDate ? "(" + ["日", "月", "火", "水", "木", "金", "土"][d.getDay()] + ")" : "";
    var metaParts = [];
    if (ev.venue) metaParts.push(ev.venue);
    if (ev.event_date) metaParts.push(formatDate(ev.event_date) + "開催");
    var thumb = ev.image ? '<div class="pn-feature-event-thumb"><img src="' + escapeHtml(ev.image) + '" alt="" loading="lazy"></div>' : '';
    return '<a class="pn-item-link" href="/blogs/media/' + escapeHtml(ev.slug) + '">' +
      '<div class="pn-feature-event">' +
      '<div class="pn-feature-event-date"><span class="pn-feature-event-day">' + escapeHtml(dayLabel) + '</span>' +
      '<span class="pn-feature-event-dow">' + escapeHtml(dowLabel) + '</span></div>' +
      thumb +
      '<div class="pn-feature-event-body">' +
      '<div class="pn-item-top"><span class="pn-badge pn-badge--feature">' + escapeHtml(badgeLabel) + '</span>' +
      (ev.regionLabel ? '<span class="pn-badge pn-badge--region">' + escapeHtml(ev.regionLabel) + '</span>' : '') + '</div>' +
      '<h3 class="pn-feature-event-title">' + escapeHtml(ev.title) + '</h3>' +
      '<p class="pn-feature-event-meta">' + escapeHtml(metaParts.join(" ・ ")) + '</p>' +
      '</div></div></a>';
  }

  function buildPickupEventItemHtml(ev) {
    var meta = formatDate(ev.event_date) + (ev.regionLabel ? " ・ " + ev.regionLabel : "");
    var thumb = ev.image ? '<div class="pn-pickup-item-thumb"><img src="' + escapeHtml(ev.image) + '" alt="" loading="lazy"></div>' : '';
    return '<li class="pn-pickup-item"><a class="pn-pickup-item-link" href="/blogs/media/' + escapeHtml(ev.slug) + '">' + thumb +
      '<div class="pn-pickup-item-body">' +
      '<p class="pn-pickup-item-title">' + escapeHtml(ev.title) + '</p>' +
      '<p class="pn-pickup-item-meta">' + escapeHtml(meta) + '</p>' +
      '</div></a></li>';
  }

  // MY AREA・イベント施設タブで使うリーフラ本体イベントの行(同じ.pn-item構造を流用)。
  // 画像があるイベントのみ.pn-item-thumbで右側に小さく表示する(画像がない大半のイベントは今まで通りテキストのみ)。
  function buildEventItemHtml(ev) {
    var metaParts = [];
    if (ev.venue) metaParts.push(ev.venue);
    metaParts.push(formatDate(ev.event_date));
    var thumb = ev.image ? '<div class="pn-item-thumb"><img src="' + escapeHtml(ev.image) + '" alt="" loading="lazy"></div>' : '';
    var html = '<li class="pn-item">';
    html += '<a class="pn-item-link" href="/blogs/media/' + escapeHtml(ev.slug) + '">';
    html += '<div class="pn-item-top"><span class="pn-badge">EVENT</span>';
    if (ev.regionLabel) html += '<span class="pn-badge pn-badge--region">' + escapeHtml(ev.regionLabel) + '</span>';
    html += '</div>';
    html += '<div class="pn-item-body"><div class="pn-item-text">' +
      '<p class="pn-item-title">' + escapeHtml(ev.title) + '</p>' +
      '<p class="pn-item-meta">' + escapeHtml(metaParts.join(" ・ ")) + '</p>' +
      '</div>' + thumb + '</div>';
    html += '</a></li>';
    return html;
  }

  var EVENTS_FACILITIES_TAB_ID = "events_facilities";

  function buildEventsFacilitiesIntroHtml() {
    var html = '<div class="pn-events-intro">' +
      '<p class="pn-events-intro-text">ここに並ぶのは、ニュースで報じられた植物・園芸・農業関連イベントの話題です。実際に来場・参加できるリーフラ掲載のワークショップ・イベント情報とは別ものなので、あわせてご案内します。</p>' +
      '<div class="pn-events-intro-ctas">' +
      '<a class="pn-events-cta-btn" href="/blogs/media/event-list">植物イベントを探す</a>' +
      '<a class="pn-events-cta-btn pn-events-cta-btn--outline" href="/pages/event-submit">植物イベントを掲載する</a>' +
      '</div></div>';
    if (state.regionEventsPreviewLoaded) {
      var carouselsHtml = COMPACT ? "" : buildRegionCarouselsHtml();
      if (carouselsHtml) {
        html += '<div class="pn-events-preview">' +
          '<p class="pn-events-preview-title">リーフラ掲載中のイベント(エリア別)</p>' +
          carouselsHtml +
          '</div>';
      } else if (COMPACT) {
        html += '<p class="pn-compact-more"><a href="/blogs/media/event-list">植物イベントを見る →</a></p>';
      }
    }
    return html;
  }

  // compactモード(ホームページ埋め込み用)の「もっと見る」リンクをリストの最後に足す。
  function appendCompactMoreLink(html) {
    return html + '<p class="pn-compact-more"><a href="' + escapeHtml(COMPACT_MORE_URL) + '">もっと見る →</a></p>';
  }

  function renderNewsPanel(tab) {
    var panelEl = qs('.pn-panel[data-tab-id="' + tab.id + '"] .pn-panel-body');
    if (!panelEl) return;
    var html = tab.id === EVENTS_FACILITIES_TAB_ID ? buildEventsFacilitiesIntroHtml() : "";
    if (state.feedError) {
      html += '<p class="pn-error-state">ニュースの取得に失敗しました。時間をおいて再度お試しください。</p>';
    } else if (!state.feedLoaded) {
      html += '<p class="pn-empty-state">読み込み中...</p>';
    } else {
      var items;
      var showCategory = tab.id === "ALL";
      if (showCategory) {
        items = [];
        Object.keys(state.feedByCategory).forEach(function (catId) {
          // "featured"はニュース各カテゴリとは別に、Shopifyから直接取得した
          // タイムライン記事の完全なアーカイブ(2026-08-31〜)。ALLの通常
          // マージには含めず、下で別途pinned表示する。
          if (catId === FEATURED_CATEGORY_ID) return;
          items = items.concat(state.feedByCategory[catId]);
        });
      } else {
        items = state.feedByCategory[tab.id] || [];
      }
      items = items.filter(matchesTagFilters).slice();
      items.sort(function (a, b) { return (b.published_at || "").localeCompare(a.published_at || ""); });

      // ALLタブでは「特集」アーカイブのうち最新の1件だけを、新着順とは別に
      // 常に最上部へ固定表示する(全件は「特集」タブ=一覧ページ相当の方で
      // 見せる)。「特集」タブへの動線として、末尾にリンクを添える。
      if (showCategory) {
        var featuredBucket = state.feedByCategory[FEATURED_CATEGORY_ID] || [];
        if (featuredBucket.length > 0) {
          // 1件だけなのでカード単体をそのまま全幅で見せる(グリッドで囲む必要は無い)。
          html += buildFeaturedCardHtml(featuredBucket[0]);
          // 2026-08-31: クエリパラメータ(?tab=featured)ではSEO資産にならないとの
          // 指摘を受け、独立したサーバーサイドレンダリングの専用ページ
          // (/pages/timeline、shop.metafields.botareco.timeline_archiveを
          // Liquidで直接描画)へのリンクに変更した。
          html += '<p class="pn-featured-more"><a href="/pages/timeline">タイムラインの一覧を見る →</a></p>';
        }
      }

      if (items.length === 0) {
        html += '<ul class="pn-list"><li class="pn-empty-state">このカテゴリには条件に一致するニュースがありません。</li></ul>';
      } else if (tab.id === FEATURED_CATEGORY_ID) {
        // 「特集」タブ自体は他のカテゴリと違い、汎用のFEATURE+続けて読むへは
        // 任せず、全アイテムを画像付きカードのグリッドとして並べる。
        html += buildFeaturedGridHtml(COMPACT ? items.slice(0, 3) : items);
        if (COMPACT) {
          html = appendCompactMoreLink(html);
        } else {
          // 2026-09-12: /pages/timeline(SSR一覧ページ)への導線がALLタブの
          // 固定表示条件に依存する1箇所しか無く、タイムラインタブ自体から
          // 一覧ページへ辿れなかった(ユーザー指摘)。タブを開けば必ず見える
          // 位置に恒常的なリンクを追加する。
          html += '<p class="pn-featured-more"><a href="/pages/timeline">タイムライン一覧ページ(全件・SEO対応版)を見る →</a></p>';
        }
      } else {
        var seriesItems = items.filter(function (it) { return it.type === "series"; });
        var normalItems = items.filter(function (it) { return it.type !== "series"; });
        var feature = normalItems[0];
        // 2026-09-12: compactモード(ホーム埋め込み)でもFEATUREの横に「続けて読む」
        // ピックアップ(LATEST相当のサイドリスト)を表示するように変更。以前は
        // ピックアップを空にしてpn-feature-solo(サイドリスト無しの単体表示)に
        // していたが、幅が広がった状態だと1枚の記事だけが間延びして見える
        // ため(ユーザー指摘、添付の参考デザインの通りFEATURE+LATESTの2カラムへ)。
        // 連載(SERIES)ボックスはcompactでは引き続き非表示。
        var pickup = normalItems.slice(1, 5);
        var rest = COMPACT ? normalItems.slice(5, 5 + COMPACT_ITEM_LIMIT) : normalItems.slice(5);

        if (feature) {
          var featureInner = buildFeatureNewsInnerHtml(feature, showCategory);
          var pickupHtml = pickup.map(buildPickupNewsItemHtml).join("");
          html += buildFeatureSectionHtml(featureInner, "続けて読む", pickupHtml);
        }

        // ALLタブは特集(pinned)と別に、通常のシリーズボックスは最新の1件だけで
        // 十分(全件出すとタイムライン記事だらけになり冗長なため)。個別カテゴリ
        // タブはそのカテゴリ内の件数がもともと少ないため、従来通り全件表示する。
        if (!COMPACT) {
          var seriesToShow = showCategory ? seriesItems.slice(0, 1) : seriesItems;
          seriesToShow.forEach(function (s) { html += buildSeriesBoxHtml(s); });
        }

        if (rest.length > 0) {
          html += '<div class="pn-sec-label"><span class="pn-sec-label-text">新着ニュース</span><span class="pn-sec-label-rule"></span></div>';
          // ところどころ(6件ごと)に広告を挟む。ホーム埋め込み(compact)は
          // 表示件数が少ないため広告は入れない。
          var AD_EVERY = 6;
          var restHtml = rest.map(function (item, i) {
            var itemHtml = buildItemHtml(item, { showCategory: showCategory });
            if (!COMPACT && i > 0 && i % AD_EVERY === 0) itemHtml = buildAdUnitHtml("pn-item pn-item--ad") + itemHtml;
            return itemHtml;
          }).join("");
          html += '<ul class="pn-list">' + restHtml + '</ul>';
        }
        if (COMPACT) html = appendCompactMoreLink(html);
      }
    }
    panelEl.innerHTML = html;
    updateScrollerHeight();
    activateAdUnitsWithin(panelEl);
  }

  /* ---------- MY AREA ---------- */
  function renderMyAreaPanel() {
    var panelEl = qs('.pn-panel[data-tab-id="MY_AREA"] .pn-panel-body');
    if (!panelEl) return;
    var html;
    if (!CUSTOMER_EMAIL) {
      html = '<div class="pn-my-area-empty"><p>MY AREA機能はログインするとご利用いただけます。ログイン後、気になるエリアをフォローすると最新イベントがここに表示されます。</p>' +
        '<a class="pn-my-area-empty-btn" href="/account/login?return_url=' + encodeURIComponent(window.location.pathname + window.location.search) + '">ログインする</a></div>';
    } else if (!state.myAreaLoaded) {
      html = '<p class="pn-empty-state">読み込み中...</p>';
    } else if (state.followedRegions.length === 0) {
      html = '<div class="pn-my-area-empty"><p>マイエリアがまだ設定されていません。フォローしたいエリアを選ぶと、そのエリアの最新イベントがここに表示されます。</p>' +
        '<a class="pn-my-area-empty-btn" href="' + escapeHtml(AREAS_URL) + '">マイエリアを設定する</a></div>';
    } else if (state.myAreaEvents.length === 0) {
      html = '<ul class="pn-list"><li class="pn-empty-state">フォロー中のエリアで、直近のイベントはまだありません。</li></ul>';
    } else {
      var maFeature = state.myAreaEvents[0];
      var maPickup = COMPACT ? [] : state.myAreaEvents.slice(1, 5);
      var maRest = COMPACT ? state.myAreaEvents.slice(1, 1 + COMPACT_ITEM_LIMIT) : state.myAreaEvents.slice(5);
      var maFeatureInner = buildFeatureEventInnerHtml(maFeature, "NEXT EVENT");
      var maPickupHtml = maPickup.map(buildPickupEventItemHtml).join("");
      html = buildFeatureSectionHtml(maFeatureInner, "近日開催", maPickupHtml);
      if (maRest.length > 0) {
        html += '<div class="pn-sec-label"><span class="pn-sec-label-text">開催予定のイベント</span><span class="pn-sec-label-rule"></span></div>';
        html += '<ul class="pn-list">' + maRest.map(buildEventItemHtml).join("") + '</ul>';
      }
      if (COMPACT) html = appendCompactMoreLink(html);
    }
    panelEl.innerHTML = html;
    updateScrollerHeight();
  }

  /* ---------- 週末のおでかけプラン(リーフレット/itineraries) ----------
     itinerariesはSupabase Edge Function(process-consultation)経由でしか取得できないため、
     このタブに限りニュースフィード(Cloudflare Workers)ではなくSupabaseを直接叩く。
     main-page-leaflets.liquidが使っている既存の公開エンドポイント(get_public_itineraries)を再利用する。 */
  var WEEKEND_PLANS_TAB_ID = "weekend_plans";

  function dayLabelFor(days) {
    if (!days) return "";
    return days === 1 ? "1day" : days + "days";
  }

  function buildFeatureLeafletInnerHtml(lf) {
    var badges = '<span class="pn-badge pn-badge--feature">WEEKEND PICK</span>';
    if (lf.areaLabel) badges += '<span class="pn-badge pn-badge--region">' + escapeHtml(lf.areaLabel) + '</span>';
    if (lf.isOfficial) badges += '<span class="pn-badge pn-badge--official">公式</span>';
    var thumb = lf.image ? '<div class="pn-feature-event-thumb"><img src="' + escapeHtml(lf.image) + '" alt="" loading="lazy"></div>' : '';
    return '<a class="pn-item-link" href="/pages/leaflet-share?t=' + escapeHtml(lf.shareToken) + '">' +
      '<div class="pn-feature-event">' + thumb +
      '<div class="pn-feature-event-body">' +
      '<div class="pn-item-top">' + badges + '</div>' +
      '<h3 class="pn-feature-event-title">' + escapeHtml(lf.title) + '</h3>' +
      '<p class="pn-feature-event-meta">' + escapeHtml(lf.dayLabel) + '</p>' +
      '</div></div></a>';
  }

  function buildPickupLeafletItemHtml(lf) {
    var thumb = lf.image ? '<div class="pn-pickup-item-thumb"><img src="' + escapeHtml(lf.image) + '" alt="" loading="lazy"></div>' : '';
    var meta = [lf.areaLabel, lf.dayLabel].filter(Boolean).join(" ・ ");
    return '<li class="pn-pickup-item"><a class="pn-pickup-item-link" href="/pages/leaflet-share?t=' + escapeHtml(lf.shareToken) + '">' + thumb +
      '<div class="pn-pickup-item-body">' +
      '<p class="pn-pickup-item-title">' + escapeHtml(lf.title) + '</p>' +
      '<p class="pn-pickup-item-meta">' + escapeHtml(meta) + '</p>' +
      '</div></a></li>';
  }

  function buildLeafletListItemHtml(lf) {
    var thumb = lf.image ? '<div class="pn-item-thumb"><img src="' + escapeHtml(lf.image) + '" alt="" loading="lazy"></div>' : '';
    var meta = [lf.areaLabel, lf.dayLabel].filter(Boolean).join(" ・ ");
    return '<li class="pn-item"><a class="pn-item-link" href="/pages/leaflet-share?t=' + escapeHtml(lf.shareToken) + '">' +
      (lf.isOfficial ? '<div class="pn-item-top"><span class="pn-badge pn-badge--official">公式</span></div>' : '') +
      '<div class="pn-item-body"><div class="pn-item-text">' +
      '<p class="pn-item-title">' + escapeHtml(lf.title) + '</p>' +
      '<p class="pn-item-meta">' + escapeHtml(meta) + '</p>' +
      '</div>' + thumb + '</div></a></li>';
  }

  function renderWeekendPlansPanel() {
    var panelEl = qs('.pn-panel[data-tab-id="' + WEEKEND_PLANS_TAB_ID + '"] .pn-panel-body');
    if (!panelEl) return;
    var html;
    if (state.weekendPlansError) {
      html = '<p class="pn-error-state">おでかけプランの取得に失敗しました。時間をおいて再度お試しください。</p>';
    } else if (!state.weekendPlansLoaded) {
      html = '<p class="pn-empty-state">読み込み中...</p>';
    } else if (state.weekendPlans.length === 0) {
      html = '<p class="pn-empty-state">公開されているおでかけプランはまだありません。</p>';
    } else {
      var feature = state.weekendPlans[0];
      var pickup = COMPACT ? [] : state.weekendPlans.slice(1, 5);
      var rest = COMPACT ? state.weekendPlans.slice(1, 1 + COMPACT_ITEM_LIMIT) : state.weekendPlans.slice(5);
      var featureInner = buildFeatureLeafletInnerHtml(feature);
      var pickupHtml = pickup.map(buildPickupLeafletItemHtml).join("");
      html = buildFeatureSectionHtml(featureInner, "今週末のおすすめ", pickupHtml);
      if (rest.length > 0) {
        html += '<div class="pn-sec-label"><span class="pn-sec-label-text">みんなのおでかけプラン</span><span class="pn-sec-label-rule"></span></div>';
        var wpRestHtml = rest.map(function (lf, i) {
          var itemHtml = buildLeafletListItemHtml(lf);
          if (!COMPACT && i > 0 && i % 6 === 0) itemHtml = buildAdUnitHtml("pn-item pn-item--ad") + itemHtml;
          return itemHtml;
        }).join("");
        html += '<ul class="pn-list">' + wpRestHtml + '</ul>';
      }
      if (COMPACT) html = appendCompactMoreLink(html);
    }
    if (!COMPACT) html += '<p class="pn-weekend-plans-create"><a href="/pages/my-itineraries">＋ 自分のおでかけプランを作る</a></p>';
    panelEl.innerHTML = html;
    updateScrollerHeight();
    activateAdUnitsWithin(panelEl);
  }

  function loadWeekendPlans() {
    var cfg = window.SUPABASE_CONFIG;
    if (!cfg || !cfg.functionsBase || !cfg.key) {
      state.weekendPlansLoaded = true;
      state.weekendPlansError = true;
      renderWeekendPlansPanel();
      return;
    }
    fetch(cfg.functionsBase + "/process-consultation?action=get_public_itineraries", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Authorization": "Bearer " + cfg.key },
      body: JSON.stringify({ per_page: 40 })
    }).then(function (res) {
      if (!res.ok) throw new Error("itineraries http " + res.status);
      return res.json();
    }).then(function (data) {
      if (!data.success || !data.leaflets) throw new Error("itineraries payload error");
      var leaflets = data.leaflets.map(function (lf) {
        return {
          title: lf.title,
          image: (lf.event_images && lf.event_images[0]) || "",
          areaLabel: (lf.area_label && lf.area_label !== "その他") ? lf.area_label : "",
          isOfficial: lf.author_type === "official",
          isTemplate: !!lf.is_template,
          dayLabel: dayLabelFor(lf.days),
          shareToken: lf.share_token
        };
      });
      // 公式のおすすめプランを先頭に寄せる(それ以外は取得順=新着順のまま)。
      leaflets.sort(function (a, b) {
        var aOfficial = (a.isOfficial && a.isTemplate) ? 1 : 0;
        var bOfficial = (b.isOfficial && b.isTemplate) ? 1 : 0;
        return bOfficial - aOfficial;
      });
      state.weekendPlans = leaflets;
      state.weekendPlansLoaded = true;
      renderWeekendPlansPanel();
    }).catch(function (err) {
      console.error("[plant-news] weekend plans load failed", err);
      state.weekendPlansLoaded = true;
      state.weekendPlansError = true;
      renderWeekendPlansPanel();
    });
  }

  function renderAllPanels() {
    TABS.forEach(function (tab) {
      if (tab.id === "MY_AREA") renderMyAreaPanel();
      else if (tab.id === WEEKEND_PLANS_TAB_ID) renderWeekendPlansPanel();
      else renderNewsPanel(tab);
    });
  }

  /* ---------- data fetch ---------- */
  function loadFeed() {
    fetch(FEED_URL, { credentials: "omit" }).then(function (res) {
      if (!res.ok) throw new Error("feed http " + res.status);
      return res.json();
    }).then(function (data) {
      var byCategory = {};
      (data.categories || []).forEach(function (cat) {
        byCategory[cat.id] = (cat.items || []).map(function (item) {
          return Object.assign({ categoryLabel: cat.label }, item);
        });
      });
      state.feedByCategory = byCategory;
      state.feedLoaded = true;
      updateFacetStatus();
      renderAllPanels();
    }).catch(function (err) {
      console.error("[plant-news] feed load failed", err);
      state.feedLoaded = true;
      state.feedError = true;
      renderAllPanels();
    });
  }

  function fetchLeaflaEventsForRegions(regionCodes) {
    if (!regionCodes.length) {
      state.myAreaEvents = [];
      state.myAreaLoaded = true;
      renderMyAreaPanel();
      return;
    }
    var today = new Date();
    var monthRequests = [0, 1].map(function (offset) {
      var d = new Date(today.getFullYear(), today.getMonth() + offset, 1);
      var monthStr = d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0");
      return fetch(EVENTS_API_BASE + "?month=" + monthStr).then(function (res) {
        return res.ok ? res.json() : { events: [] };
      }).catch(function () { return { events: [] }; });
    });
    Promise.all(monthRequests).then(function (results) {
      var todayStr = today.toISOString().slice(0, 10);
      var all = [];
      results.forEach(function (data) { all = all.concat(data.events || data.data || []); });
      var filtered = all.filter(function (ev) {
        if (!ev.event_date || ev.event_date < todayStr) return false;
        var regions = ev.regions || [];
        return regions.some(function (r) { return regionCodes.indexOf(r) >= 0; });
      });
      filtered.sort(function (a, b) { return (a.event_date || "").localeCompare(b.event_date || ""); });
      state.myAreaEvents = filtered.slice(0, 20).map(function (ev) {
        var matchedRegion = (ev.regions || []).filter(function (r) { return regionCodes.indexOf(r) >= 0; })[0];
        return { title: ev.title, venue: ev.venue, event_date: ev.event_date, slug: ev.slug, image: ev.image_url || "", regionLabel: REGION_LABELS[matchedRegion] || "" };
      });
      state.myAreaLoaded = true;
      renderMyAreaPanel();
    });
  }

  // 「イベント・施設」タブ用: 関東・関西などの広域エリアごとに直近開催イベントを
  // まとめ、エリア別カルーセルとして表示する(2026-08-30、ユーザー要望で単なる
  // 数件プレビューから拡張)。エリア分けはmain-page-venues.liquidの地域ピルと
  // 同じ優先順位(関東→関西→中部→東北→九州→北海道→中国→四国→沖縄)。
  var BROAD_REGIONS_ORDER = ["KANTO", "KANSAI", "CHUBU", "TOHOKU", "KYUSHU", "HOKKAIDO", "CHUGOKU", "SHIKOKU", "OKINAWA"];
  var REGION_CAROUSEL_MONTHS = 3; // 当月+2ヶ月先まで
  var REGION_CAROUSEL_LIMIT = 12; // エリアごとの最大表示件数

  function loadRealEventsPreview() {
    var today = new Date();
    var monthRequests = [];
    for (var i = 0; i < REGION_CAROUSEL_MONTHS; i++) {
      (function (offset) {
        var d = new Date(today.getFullYear(), today.getMonth() + offset, 1);
        var monthStr = d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0");
        monthRequests.push(fetch(EVENTS_API_BASE + "?month=" + monthStr).then(function (res) {
          return res.ok ? res.json() : { events: [] };
        }).catch(function () { return { events: [] }; }));
      })(i);
    }
    Promise.all(monthRequests).then(function (results) {
      var todayStr = today.toISOString().slice(0, 10);
      var all = [];
      results.forEach(function (data) { all = all.concat(data.events || data.data || []); });
      var upcoming = all.filter(function (ev) { return ev.event_date && ev.event_date >= todayStr; });
      upcoming.sort(function (a, b) { return (a.event_date || "").localeCompare(b.event_date || ""); });

      var byRegion = {};
      BROAD_REGIONS_ORDER.forEach(function (code) { byRegion[code] = []; });
      upcoming.forEach(function (ev) {
        var regions = ev.regions || [];
        BROAD_REGIONS_ORDER.forEach(function (code) {
          if (regions.indexOf(code) < 0) return;
          if (byRegion[code].length >= REGION_CAROUSEL_LIMIT) return;
          byRegion[code].push({
            title: ev.title, venue: ev.venue, event_date: ev.event_date,
            slug: ev.slug, image: ev.image_url || "",
          });
        });
      });
      state.regionEventsPreview = byRegion;
      state.regionEventsPreviewLoaded = true;
      var tab = TABS.filter(function (t) { return t.id === EVENTS_FACILITIES_TAB_ID; })[0];
      if (tab) renderNewsPanel(tab);
    });
  }

  // エリア別カルーセルの1枚のカード(横スクロール、固定幅)。
  function buildEventCarouselCardHtml(ev) {
    var d = ev.event_date ? new Date(ev.event_date + "T00:00:00") : null;
    var validDate = d && !isNaN(d.getTime());
    var dateLabel = validDate
      ? (d.getMonth() + 1) + "/" + String(d.getDate()).padStart(2, "0") + "(" + ["日", "月", "火", "水", "木", "金", "土"][d.getDay()] + ")"
      : "";
    var thumb = ev.image
      ? '<div class="pn-carousel-card-thumb"><img src="' + escapeHtml(ev.image) + '" alt="" loading="lazy"></div>'
      : '<div class="pn-carousel-card-thumb pn-carousel-card-thumb--empty">🌿</div>';
    return '<a class="pn-carousel-card" href="/blogs/media/' + escapeHtml(ev.slug) + '">' + thumb +
      '<div class="pn-carousel-card-body">' +
      '<p class="pn-carousel-card-date">' + escapeHtml(dateLabel) + '</p>' +
      '<p class="pn-carousel-card-title">' + escapeHtml(ev.title) + '</p>' +
      (ev.venue ? '<p class="pn-carousel-card-venue">' + escapeHtml(ev.venue) + '</p>' : '') +
      '</div></a>';
  }

  // 1エリア分のカルーセルブロック(見出し+横スクロール行)。
  function buildRegionCarouselHtml(regionCode, events) {
    var label = REGION_LABELS[regionCode] || regionCode;
    var cardsHtml = events.map(buildEventCarouselCardHtml).join("");
    return '<div class="pn-region-carousel-block">' +
      '<div class="pn-sec-label"><span class="pn-sec-label-text">' + escapeHtml(label) + 'のイベント</span><span class="pn-sec-label-rule"></span>' +
      '<a class="pn-region-carousel-more" href="/blogs/media/event-list">もっと見る</a></div>' +
      '<div class="pn-carousel-scroll">' + cardsHtml + '</div>' +
      '</div>';
  }

  // 全エリア分のカルーセルをまとめて組み立てる(イベントが1件も無いエリアは省く)。
  function buildRegionCarouselsHtml() {
    var html = "";
    BROAD_REGIONS_ORDER.forEach(function (code) {
      var events = state.regionEventsPreview[code] || [];
      if (events.length === 0) return;
      html += buildRegionCarouselHtml(code, events);
    });
    return html;
  }

  function loadMyArea() {
    if (!CUSTOMER_EMAIL) { renderMyAreaPanel(); return; }
    fetch(FOLLOWS_BASE_URL + encodeURIComponent(CUSTOMER_EMAIL), { credentials: "omit" }).then(function (res) {
      if (!res.ok) throw new Error("follows http " + res.status);
      return res.json();
    }).then(function (data) {
      state.followedRegions = data.regions || [];
      renderMyAreaPanel();
      fetchLeaflaEventsForRegions(state.followedRegions);
    }).catch(function (err) {
      console.error("[plant-news] my-area load failed", err);
      state.myAreaLoaded = true;
      renderMyAreaPanel();
    });
  }

  /* ---------- event delegation ---------- */
  function initEvents() {
    var tabRow = qs("#pnTabRow");
    if (tabRow) {
      tabRow.addEventListener("click", function (e) {
        var btn = e.target.closest(".pn-tab");
        if (btn) jumpToPanel(Number(btn.getAttribute("data-idx")));
      });
    }

    var prevBtn = qs("#pnFlickPrev");
    if (prevBtn) prevBtn.addEventListener("click", function () { jumpToPanel(Math.max(0, state.activeIndex - 1)); });
    var nextBtn = qs("#pnFlickNext");
    if (nextBtn) nextBtn.addEventListener("click", function () { jumpToPanel(Math.min((TABS.length || 1) - 1, state.activeIndex + 1)); });

    var facetPanel = qs("#pnFacetPanel");
    if (facetPanel) {
      facetPanel.addEventListener("click", function (e) {
        if (e.target.closest("[data-action='toggle-panel']")) {
          var body = qs("#pnFacetPanelBody");
          var chevron = qs("#pnFacetPanelChevron");
          var open = body.style.display !== "none";
          body.style.display = open ? "none" : "";
          if (chevron) chevron.classList.toggle("pn-chevron--open", !open);
          return;
        }
        var groupHead = e.target.closest("[data-action='toggle-group']");
        if (groupHead) {
          var groupBody = groupHead.parentElement.querySelector(".pn-facet-options");
          var groupChevron = groupHead.querySelector(".pn-chevron");
          var isOpen = groupBody.style.display !== "none";
          groupBody.style.display = isOpen ? "none" : "";
          if (groupChevron) groupChevron.classList.toggle("pn-chevron--open", !isOpen);
          return;
        }
        if (e.target.closest("[data-action='clear-tags']")) { clearTags(); return; }
        var chipBtn = e.target.closest("[data-action='remove-chip']");
        if (chipBtn) { toggleTag(chipBtn.getAttribute("data-dim"), chipBtn.getAttribute("data-value")); }
      });
      facetPanel.addEventListener("change", function (e) {
        var cb = e.target.closest(".pn-facet-option input[type='checkbox']");
        if (cb) toggleTag(cb.getAttribute("data-dim"), cb.getAttribute("data-value"));
      });
    }

    var mainScroll = qs("#pnMainScroll");
    if (mainScroll) {
      mainScroll.addEventListener("click", function (e) {
        var toggleBtn = e.target.closest("[data-action='toggle-series']");
        if (!toggleBtn) return;
        var id = toggleBtn.getAttribute("data-id");
        state.expandedSeries[id] = !state.expandedSeries[id];
        renderAllPanels();
      });
    }
  }

  // URLの?tab=<id>で該当タブへ直接ジャンプする(「特集の一覧を見る」等、
  // フリック外からこのページの特定タブへ直接リンクするための動線)。
  // compact(ホーム埋め込み)側では使わない想定(そちらはリンク先が常に
  // フルページ/pages/plant-newsなので、ここが実行されるのはフルページ側のみ)。
  function initTabFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var wanted = params.get("tab");
    if (!wanted) return;
    var idx = -1;
    for (var i = 0; i < TABS.length; i++) {
      if (TABS[i].id === wanted) { idx = i; break; }
    }
    if (idx < 0) return;
    var scroller = qs("#pnMainScroll");
    if (scroller) {
      var width = scroller.clientWidth || 1;
      scroller.scrollLeft = idx * width;
    }
    setActiveIndex(idx);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initEvents();
    initScrollSync();
    initDragScroll();
    updateFlickNavButtons();
    initTabFromUrl();
    loadFeed();
    loadMyArea();
    loadRealEventsPreview();
    loadWeekendPlans();
    var resizeTimer = null;
    window.addEventListener("resize", function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(updateScrollerHeight, 150);
    });
  });
})();
